import { ITabOption, TTranslator } from '@smartshell/ui-kit';

import { Combo, EPaymentMethod, TShopItem } from 'types';

import { ISendingPaymentItem } from '../hooks';
import { TLocalesKeys } from '../localization';
import { getItemTotalPrice } from './utils';

const getCartItems = (
  items: TShopItem[],
  combo: Combo | null,
  activeDiscount: number | null,
  hostIds?: number[]
): ISendingPaymentItem[] => {
  const arr: ISendingPaymentItem[] = [];

  items
    .filter(({ comboId }) => !comboId)
    .forEach((item) => {
      if (hostIds && hostIds.length > 0) {
        hostIds.forEach((hostId) => {
          arr.push({
            type: item.type,
            amount: item.amount,
            sum: getItemTotalPrice(item, activeDiscount ?? null),
            entity_id: item.id,
            host_id: hostId,
          });
        });
      } else {
        arr.push({
          type: item.type,
          amount: item.amount,
          sum: getItemTotalPrice(item, activeDiscount ?? null),
          entity_id: item.id,
        });
      }
    });

  if (combo) {
    if (hostIds && hostIds.length > 0) {
      hostIds.forEach((hostId) => {
        arr.push({
          type: 'COMBO',
          amount: 1,
          sum: combo.cost,
          entity_id: combo.id,
          host_id: hostId,
        });
      });
    } else {
      arr.push({
        type: 'COMBO',
        amount: 1,
        sum: combo.cost,
        entity_id: combo.id,
      });
    }
  }

  return arr;
};

const getPaymentMethod = (
  t: TTranslator<TLocalesKeys>,
  depositDisabled: boolean,
  compositeDisabled?: boolean
): Array<ITabOption<EPaymentMethod>> => [
  {
    iconName: 'MoneyIcon',
    value: EPaymentMethod.CASH,
    title: t('money.cash'),
  },
  {
    iconName: 'CreditCardIcon',
    value: EPaymentMethod.CARD,
    title: t('money.card'),
  },
  {
    iconName: 'WalletIcon',
    value: EPaymentMethod.DEPOSIT,
    disabled: depositDisabled,
    title: t('money.deposit'),
  },
  {
    iconName: 'CompositeIcon',
    value: EPaymentMethod.COMPOSITE,
    disabled: compositeDisabled,
    title: t('money.split'),
  },
];

export { getCartItems, getPaymentMethod };
